import { defineComponent as _defineComponent } from 'vue'
import Wizard from '@/components/wizard/Wizard.vue';
import PersonalDataWizardStep from './steps/PersonalDataWizardStep.vue';
import SubsidiaryMembershipWizardStep from './steps/SubsidiaryMembershipWizardStep.vue';
import SummaryWizardStep from './steps/SummaryWizardStep.vue';
import { User } from '@/models/user';
import { useUserWizard } from './user-wizard-utils';
import { subsidiariesService } from '@/services/subsidiaries.service';
import { currentUser } from '@/utils/permissionUtils';
import { computed } from 'vue';
import { isNil } from '@/utils/misc';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SubsidiaryAdminWizard',
  props: {
    user: { default: null },
    subsidiaryId: null
  },
  emits: ['close', 'save'],
  setup(__props: any, { emit }) {

const props = __props as { user: User | null, subsidiaryId?: number };





const { t } = useI18n();

const {
  userCopy,
  isEdit,
  submit: onSubmit,
} = useUserWizard(props, emit, User.emptySubsidiaryAdmin(), async () => {
  if (!isNil(props.subsidiaryId)) {
    userCopy.value!.subsidiaryId = props.subsidiaryId;
    userCopy.value!.subsidiaryName = await subsidiariesService.getNameById(
      props.subsidiaryId,
    );
  } else if (currentUser().isSubsidiaryAdmin) {
    userCopy.value!.subsidiaryId = currentUser().subsidiaryId;
    userCopy.value!.subsidiaryName = await subsidiariesService.getNameById(
      currentUser().subsidiaryId!,
    );
  }
});

const shouldHideMembershipStep = computed(
  () =>
    isHandlingUserFromSubsidiaryUserList.value ||
    isUserEditingItself.value ||
    currentUser().isSubsidiaryAdmin,
);

const isHandlingUserFromSubsidiaryUserList = computed(
  () => !isNil(props.subsidiaryId),
);

const isUserEditingItself = computed(() => currentUser().id === props.user?.id);

return { __sfc: true,props, emit, t, userCopy, isEdit, onSubmit, shouldHideMembershipStep, isHandlingUserFromSubsidiaryUserList, isUserEditingItself, Wizard, PersonalDataWizardStep, SubsidiaryMembershipWizardStep, SummaryWizardStep }
}

})